import { PathType } from "./PathType";
import Home from '../../../../../assets/home.svg';
import Home_Active from '../../../../../assets/home_active.svg';
import Mediacal_emergency from '../../../../../assets/pulse_alert.svg';
import Mediacal_emergency2 from '../../../../../assets/pulse_alert_active.svg';
import User from '../../../../../assets/history.svg';
import User_Active from '../../../../../assets/history_active.svg';
import admin from '../../../../../assets/admin.png';
import Role from '../../../../../assets/roles.svg';
import Role_Active from '../../../../../assets/roles_active.svg';
import corporate from  '../../../../../assets/corporate_fare (1).svg';
import corporate_active from '../../../../../assets/corporate_active.svg';
import UserActivity from '../../../../../assets/userActivity.svg';
import activeUserActivity from '../../../../../assets/user_activity.svg';
import inActiveFlights from '../../../../../assets/inActiveFlights.svg'
import ActivePane from '../../../../../assets/ActivePane.svg'
import inActive from "../../../../../assets/medicalKit_InActive.svg"
import ActiveM from "../../../../../assets/medicalKit_Active.svg"
import passenger from '../../../../../assets/Group 2858.svg'
import passenger_active from "../../../../../assets/Group 2858 (1).svg";
import form from "../../../../../assets/form.svg";
import form_active from "../../../../../assets/form(2).svg";


export const SuperAdminPath: PathType[] = [

  {
    path: "/home",
    label: "Home",
    icon: Home,
    icon_active: Home_Active
  },
  {
    path: "/ems/medical-emergencies",
    label: "Active Incidents",
    icon: Mediacal_emergency,
    icon_active: Mediacal_emergency2
  },
  {
    path: "/users",
    label: "Users",
    icon: User,
    icon_active: User_Active
  },
  {
    path: "/user-activity",
    label: "Users Activity",
    icon: activeUserActivity,
    icon_active: UserActivity
  },
  {
    path: "/flights",
    label: "Flights",
    icon: inActiveFlights ,
    icon_active: ActivePane
  },
  {
    path: "/roles",
    label: "Roles",
    icon: Role,
    icon_active: Role_Active
  },
  {
    path: "/organization",
    label: "Organizations",
    icon: corporate,
    icon_active: corporate_active
  },
  {
    path: "/medicalkit",
    label: "Medical Kit",
    icon: inActive ,
    icon_active: ActiveM
  },
  {
    path: "/passengers",
    label: "Passengers",
    icon: passenger,
    icon_active:passenger_active
  },
  {
    path: "/submittedforms",
    label: "Skali Onboarding Guide",
    icon: form,
    icon_active:form_active
  },
  {
    path: "/medicalEventReportFormList",
    label: "Medical Event Report",
    icon: form,
    icon_active:form_active
  }, 
  // {
  //   path: "/FitToFly",
  //   label: "Fit To Fly",
  //   icon: form,
  //   icon_active:form_active
  // },
  // {
  //   path: "/FitToFlyflow",
  //   label: "Fit To Fly Flow",
  //   icon: form,
  //   icon_active:form_active
  // }
];
